// ProjectsList.js
import React, { useState, useEffect } from 'react';
import { FetchHubs} from '../api/hubsService';
import { useGlobalProvider } from '../contexts/GlobalProvider';
import { useAuth } from '../contexts/AuthContext';

const HubsList = () => {
    const [items, setItems] = useState([]);
    const { loginStatus, selectedHubId, setSelectedHubId, setSelectedHubRegion, validateHubSelection } = useGlobalProvider();
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(true);
    const { getAccessToken } = useAuth();


    const fetchHubs = async () => {
        setLoading(true);
        try {
            const accessToken = await getAccessToken();
            const hubsList = await FetchHubs(accessToken);
            console.log(hubsList);

            if (hubsList && hubsList.length > 0) {
                setItems(hubsList);
                // Validate current selection against available hubs
                validateHubSelection(hubsList);
            } else {
                console.log("No hubs returned from API", hubsList);
            }
        } catch (err) {
            console.error("API Error:", err);
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    // useEffect to fetch hubs when loginStatus is true
    useEffect(() => {
        if (loginStatus) {
            fetchHubs();
        }
    }, [loginStatus]);

    const handleSelectedHubId = (event) => {
        const selectedHubId = event.target.value;
        setSelectedHubId(selectedHubId);
        
        // Find the selected hub and extract its region
        const selectedHub = items.find(hub => hub.id === selectedHubId);
        if (selectedHub && selectedHub.attributes && selectedHub.attributes.region) {
            setSelectedHubRegion(selectedHub.attributes.region);
            console.log('Selected hub region:', selectedHub.attributes.region);
        } else {
            setSelectedHubRegion('');
            console.log('No region found for selected hub');
        }
    };

    // if (loading) {
    //     return <div>Loading Hubs...</div>;
    // }

    if (error) {
        return <div>Error loading data: {error}</div>;
    }

    return (
        <div className="select-container">
            {loginStatus && (
                <select className="form-select" value={selectedHubId || ""} onChange={handleSelectedHubId}>
                    <option value="" disabled>Select Account</option>
                    {items.map(hub => (
                        <option key={hub.id} value={hub.id}>
                            {hub.attributes.name} {hub.attributes.region ? `(${hub.attributes.region})` : ''}
                        </option>
                    ))}
                </select>
            )}
        </div>
    );
};

export default HubsList;
